/*
  Load more / infinite scroll for product listings.

  Replaces the numbered pagination on collection and search pages. The paginate
  markup stays in the DOM untouched - it is the no-JS fallback and what search
  engines follow - and is only hidden once this script has successfully taken
  over.

  How it works: fetch the URL of the pagination "next" link, parse it, move its
  #product-grid children into the current grid, then swap in its pagination
  block so the next link points one page further on.

  Auto-loading stops after AUTO_LIMIT pages so the footer stays reachable;
  after that the button has to be clicked. Filtering or sorting re-renders the
  whole section, which resets this back to page one - correct behaviour, and the
  observer below re-attaches to the fresh markup.
*/
(function () {
  var AUTO_LIMIT = 2;

  /*
    On collection pages #product-grid is the <ul> itself. On the search page it
    is a wrapping <div> holding the loading overlay, the <ul> and the pagination.
    Appending to the wrapper there dropped the new products below the Load more
    button, so resolve to the list either way.
  */
  function gridOf(root) {
    var el = root.getElementById ? root.getElementById('product-grid') : root.querySelector('#product-grid');
    if (!el) return null;
    if (el.tagName === 'UL') return el;
    return el.querySelector('ul.product-grid') || el.querySelector('ul.grid') || el;
  }

  function hrefForPage(wrapper, n) {
    var links = wrapper.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var m = links[i].getAttribute('href').match(/[?&]page=(\d+)/);
      if (m && parseInt(m[1], 10) === n) return links[i].getAttribute('href');
    }
    return null;
  }

  function setup(wrapper) {
    if (!wrapper || wrapper.dataset.pvLoadMore) return;
    var grid = gridOf(document);
    if (!grid) return;
    // This theme's pagination snippet labels the forward arrow --prev, so the
    // next page is found by number rather than by class name.
    var page = parseInt(wrapper.dataset.page || '1', 10) || 1;
    if (!hrefForPage(wrapper, page + 1)) return;

    wrapper.dataset.pvLoadMore = '1';
    wrapper.classList.add('pv-loadmore-active');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pv-loadmore__btn';
    btn.textContent = 'Load more';
    wrapper.appendChild(btn);

    var autoUsed = 0;
    var busy = false;

    function currentNext() {
      return hrefForPage(wrapper, page + 1);
    }

    function finish() {
      btn.remove();
      var nav = wrapper.querySelector('.pagination');
      if (nav) nav.remove();
      if (observer) observer.disconnect();
    }

    function load() {
      var url = currentNext();
      if (!url || busy) return;
      busy = true;
      btn.disabled = true;
      btn.textContent = 'Loading…';

      fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = gridOf(doc);
          if (!newGrid) throw new Error('no grid');

          var items = newGrid.querySelectorAll('.grid__item');
          for (var i = 0; i < items.length; i++) {
            // Reveal animations are keyed off a class the observer adds on
            // entry; appended items would otherwise stay at opacity 0.
            items[i].classList.remove('scroll-trigger', 'animate--slide-in');
            items[i].removeAttribute('style');
            grid.appendChild(items[i]);
          }

          var newPag = doc.querySelector('.pagination-wrapper .pagination');
          var oldPag = wrapper.querySelector('.pagination');
          if (newPag && oldPag) oldPag.replaceWith(newPag);
          else if (oldPag) oldPag.remove();

          page += 1;
          try {
            history.replaceState({}, '', url);
          } catch (e) {}

          busy = false;
          btn.disabled = false;
          btn.textContent = 'Load more';
          if (!currentNext()) finish();
        })
        .catch(function () {
          // Leave the real pagination in place so the page is still usable.
          busy = false;
          wrapper.classList.remove('pv-loadmore-active');
          btn.remove();
        });
    }

    btn.addEventListener('click', function () {
      autoUsed = AUTO_LIMIT; // a deliberate click switches auto-loading off
      load();
    });

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          if (autoUsed >= AUTO_LIMIT || busy) return;
          autoUsed++;
          load();
        },
        { rootMargin: '300px' }
      );
      observer.observe(btn);
    }
  }

  function scan() {
    setup(document.querySelector('.pagination-wrapper'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  new MutationObserver(function () {
    scan();
  }).observe(document.body, { childList: true, subtree: true });
})();
